/* ============================================================
   HORCERY — Product value tabs (ARIA tablist, roving tabindex).
   No-JS: first panel shows, others hidden but present.
   ============================================================ */
(function () {
  'use strict';

  function initTabs(section) {
    if (!section || section.__hzInit) return;
    section.__hzInit = true;

    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-hz-tab]'));
    var panels = Array.prototype.slice.call(section.querySelectorAll('[data-hz-panel]'));
    if (tabs.length < 2) return;

    var select = function (idx, focus) {
      tabs.forEach(function (tab, i) {
        var on = i === idx;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
        if (panels[i]) panels[i].hidden = !on;
      });
      if (focus && tabs[idx]) tabs[idx].focus();
    };

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(i); });
      tab.addEventListener('keydown', function (e) {
        var last = tabs.length - 1;
        var next;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = i === last ? 0 : i + 1;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = i === 0 ? last : i - 1;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = last;
        else return;
        e.preventDefault();
        select(next, true);
      });
    });

    // Swipe between tabs (horizontal only, so vertical scroll is unaffected)
    var current = function () { for (var i = 0; i < tabs.length; i++) { if (tabs[i].getAttribute('aria-selected') === 'true') return i; } return 0; };
    var sx = null, sy = null;
    section.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    section.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      sx = null;
      if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      var c = current();
      if (dx < 0 && c < tabs.length - 1) select(c + 1);
      else if (dx > 0 && c > 0) select(c - 1);
    }, { passive: true });
  }

  function initAll() { document.querySelectorAll('[data-hz-tabs]').forEach(initTabs); }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-hz-tabs]');
    if (el) { el.__hzInit = false; initTabs(el); }
  });
})();
